import React from "react";
import "./AboutUs.css";
import AboutImage from "../../../../assets/images/aboutus-img.png";
import AboutDots from "../../../../assets/images/aboutus-dots.png";
const AboutUs = () => {
  return (
    <div className="about__us_section">
      <img src={AboutDots} alt="" className="aboutus__section_dots" />
      <div className="aboutus__section_left">
        <div className="aboutus__secleft_title">Who we are</div>
        <div className="aboutus__secleft_heading">
          we specialize in accounting and tax preparation services for a wide
          array of clients.
        </div>
        <div className="aboutus__secleft_description">
          <p>
            We are an esteemed CPA firm committed towards helping our clients
            navigate through the complicated rules of U.S tax filing. Our main
            purpose is to make the tax filing process as simple as possible for
            each and every client. We provide continual assistance and expertise
            in tax planning and preparation.
          </p>
          <p>
            We take care of most Indian Corporations and individuals who
            encounter more complex questions when it comes to understanding the
            United States Tax system.
          </p>
        </div>
      </div>
      <div className="aboutus__section_right">
        <img src={AboutImage} alt="" className="aboutus__section_img" />
      </div>
    </div>
  );
};

export default AboutUs;
